module.exports = __webpack_public_path__ + "img/icon_map_3_off_011.4712f649.png";